module.exports = __webpack_public_path__ + "static/img/2-19.d738f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2-19.png
// module id = eRbg
// module chunks = 15